import {
  saveAuthToken,
  loadAuthToken,
  clearTokenStorage,
  saveSessionId,
} from 'utils/tokenStorage';
import { isNetworkOffline } from 'api/utils';
import pearClient from 'api/pearClient';

import { WeaverApiClientInstance } from 'api/weaverApiClientInstance';
import Program from 'utils/program';
import { AuthClientInstance } from 'api/authClientInstance';

export const requestLogout = async (
  isTimeout: boolean = false,
): Promise<void> => {
  const token = loadAuthToken();
  if (token) {
    if (!isNetworkOffline()) {
      pearClient.v2.tracking.trackLogoutEvent(isTimeout);
      await AuthClientInstance.get().logout({ logoutRequestDto: { token } });
    }

    clearTokenStorage();
    Program.clear();
  }
};

export const login = async (
  token: string,
): Promise<{ profile: UserProfileDTO }> => {
  saveAuthToken(token);
  saveSessionId();
  pearClient.v2.tracking.trackLoginEvent();

  const { data: profile } = await WeaverApiClientInstance.getUserProfile();
  return { profile };
};
